import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/test/TestStyles.module.css';

/**
 * ExplanationBox component for displaying question explanations
 */
const ExplanationBox = ({ explanation }) => {
  if (!explanation) return null;
  
  return (
    <div className={styles.explanationBox}>
      <p className={styles.explanationTitle}>Explicación:</p>
      <p>{explanation}</p>
    </div>
  );
};

ExplanationBox.propTypes = {
  explanation: PropTypes.string
};

export default ExplanationBox;